module.exports = __webpack_public_path__ + "media/NeueHaasUnicaW1G-Heavy.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/NeueHaasUnicaW1G/NeueHaasUnicaW1G-Heavy.ttf
// module id = 1581
// module chunks = 57